export default "__VITE_PUBLIC_ASSET__3be474a2__"